
import React, { useEffect, useState } from 'react';
import Select from "react-select";
import PropTypes from 'prop-types';
import PdfImg from './pdf.svg';
import Swal from "sweetalert2";
import Axios from 'axios';
import { API_BASE_URL, UPLOAD_FILES, GET_DOCS } from '../Config';


const UploadFiles = ({ number, type }) => {
    
    const [userDataSession, setUserDataSession] = useState(null);
    const [docsData, setDocsData] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [selectedTypeOption, setSelectedTypeOption] = useState(null);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [uploadFileName, setUploadFileName] = useState("");
    const [typeError, setTypeError] = useState("");
    const [docsLoading, setDocsLoading] = useState(false);
    const [gettingType, setGettingType] = useState("");

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
        console.log(number, type);
    }, []);

    const [offcanvasWidth, setOffcanvasWidth] = useState("45%");

    useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth < 768) {
            setOffcanvasWidth("85%");
        } else {
            setOffcanvasWidth("40%");
        }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (type === 'StockTransfered') {
            setGettingType('Stock');
        }
        else if (type === 'StockReceived') {
            setGettingType('Stock');
        } else {
            setGettingType(type);
        }
    }, [type]);   

    const fetchDocsData = () => {
        if (userDataSession && userDataSession.OrgId && number && gettingType) {
            setDocsLoading(true);
            Axios.get(`${API_BASE_URL}${GET_DOCS}?OrgId=${userDataSession.OrgId}&ReferenceId=${number}&ReferenceType=${gettingType}`)
                .then(response => {
                    if (response.data.Status) {
                        setDocsData(response.data.ResultData);
                        console.log(response.data.ResultData, 'get docs data');
                        setDocsLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data);
                        setDocsLoading(false);
                        setDocsData([]);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setDocsLoading(false);
                    setDocsData([]);
                });
        }
    };

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId && number && gettingType){
            fetchDocsData();
        }
    
    }, [userDataSession, number, gettingType]);
    
    const selectOptions = [ 
        { value: "", label: "Choose type", isDisabled: true },
        { value: "Invoice", label: "Invoice" },
        { value: "Delivery Challan", label: "Delivery Challan" },
        { value: "Consignment Receipt", label: "Consignment Receipt" },
        { value: "Goods", label: "Goods" },
    ];       

    const handleTypeSelectChange = (option) => {
        setSelectedTypeOption(option);
        setTypeError('');
    };

    const fileInputRef = React.useRef(null);

    const handleEditImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setErrorMessage('');
        setTypeError('');
        if (file) {
            setUploadFileName(file.name);
            const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            if (!validFileTypes.includes(file.type)) {
                setErrorMessage('Please select a valid image file (jpeg, jpg, png, or pdf).');
                return;
            }
        
            if (file.name.includes(" ")) {
                setErrorMessage('File name contains spaces. Please rename the file without spaces.');
                return;
            }
        
            if (file.size > 2 * 1024 * 1024) {
                setErrorMessage('File size exceeds 2 MB.');
                return;
            }
        
            setErrorMessage("");
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                // setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);
        setErrorMessage('');
        setTypeError('');
        console.log('Before rendering UploadFiles:', number, type);
    
        if (!selectedTypeOption) {
            setTypeError('Please select type..');
            setSubmitBtnLoading(false);
            return;
        }
    
        if (!selectedFile) {
            setTypeError('Please choose file..');
            setSubmitBtnLoading(false);
            return;
        }
    
        if (docsData?.length >= 6) {
            setTypeError("Upload limit reached. You cannot upload more than 6 files.");
            setSubmitBtnLoading(false);
            return;
        }
        
        console.log(number, type, 'id and type sending to service...2');
    
        const formPayload = new FormData();
        formPayload.append('OrgId', userDataSession.OrgId);
        formPayload.append('ReferenceId', number);
        formPayload.append('ReferenceType', type);
        formPayload.append('DocType', selectedTypeOption.value);
        formPayload.append('userId', userDataSession.UserId);
    
        if (selectedFile) {
            formPayload.append('file', selectedFile);
            setTypeError('');
        }
    
        Axios.post(`${API_BASE_URL}${UPLOAD_FILES}`, formPayload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            setSubmitBtnLoading(false);
            console.log(response.data.ResultData, 'api resposne');
            
            if (response.data.ResultData[0].Status === 'Success') {
                Swal.fire({
                    title: `File Uploaded Successfully.`,
                    icon: "success",
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        fetchDocsData();
                    }
                });
            } else {
                setSubmitBtnLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to Request Submit.",
                    icon: "error",
                });
            }
        })
        .catch(error => {
            setSubmitBtnLoading(false);
            console.error('Error adding brand:', error);
        });
    };

    const getFileTypeImage = (filePath) => {
        const fileExtension = filePath?.split('.').pop().toLowerCase();
        const isImage = ['jpeg', 'jpg', 'png'].includes(fileExtension);
        return isImage ? `https://pcuploadfiles.azurewebsites.net/download?path=${filePath}` : PdfImg;
    };

    return (
        <div>
            {/* Uplaod Files */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightUploadFiles"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: offcanvasWidth }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Upload Files</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        // onClick={handleRemove}
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form>
                        {submitBtnLoading ? <div className='loader m-auto'></div> :
                            <div className='row'>
                                <p className='fw-semibold text-danger'>{typeError}</p>
                                {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                                <div className="col-lg-12 col-sm-12 col-12 d-flex">
                                    <div className="col-4">
                                        <label>Type<span className="fw-bold text-danger">*</span></label>
                                        <Select
                                            className="select"
                                            options={selectOptions}
                                            value={selectedTypeOption}
                                            onChange={handleTypeSelectChange} 
                                            placeholder="Choose type"
                                        />
                                    </div>
                                    <div className="drag-drop text-center col-6">
                                        <div 
                                            className="upload"
                                            onClick={handleEditImageClick}
                                        >
                                            <a href="#"><img src="assets/img/icons/drag-drop.svg" style={{ width: '3rem' }} alt="Drag and drop"/></a>
                                            <p>Choose <a href="#">file to upload</a></p>
                                            <h5 className='text-primary'>{uploadFileName}</h5>
                                        </div>
                                        <input 
                                            type="file"
                                            style={{ display: 'none' }}
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            accept=".jpg, .jpeg, .png, .pdf"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className='btn btn-success d-flex justify-content-center align-items-center m-auto mt-4 col-2 text-center'
                                        onClick={handleSubmit}
                                    >
                                        Upload
                                    </button>
                                </div>
                            </div>
                        }
                    </form>

                    {/* <div className="row g-3 mt-3">
                        {docsLoading ? (
                            <div className='loader m-auto'></div>
                        ) : (
                            <>
                            <h6>Uploaded Data</h6>
                            {docsData?.map((item, index) => (
                                <div className="col-12 col-md-4" key={index}>
                                    <div style={{ position: 'relative' }} className="profile-info">
                                        <div className="profile-pic" style={{ position: 'relative', display: 'inline-block' }}>
                                            <img
                                                src={getFileTypeImage(item.FilePath)}
                                                className="rounded img-fluid"
                                                alt={`File ${index}`}
                                                style={{ width: '100%', height: '5rem' }}
                                            />
                                                <a
                                                    href={`https://pcuploadfiles.azurewebsites.net/download?path=${item.FilePath}`}
                                                    download={`File-${index}`}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '3px',
                                                        right: '3px',
                                                        color: 'white',
                                                        fontSize: '15px',
                                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                        padding: '5px',
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                <i 
                                                    className="fa-solid fa-download"
                                                    title="Download file"
                                                ></i>
                                            </a>
                                        </div>
                                        <p className='text-center fw-bold text-info'>{item.DocType}</p>
                                    </div>
                                </div>
                            ))}
                            </>
                        )}
                    </div> */}

                    <div className="row g-3 mt-3">
                        {docsLoading ? (
                            <div className="loader m-auto"></div>
                        ) : (
                            <>
                            {/* Stock Received Documents */}
                            {docsData.some((item) => item.ReferenceType === "StockReceived") && (
                                <>
                                <h5 className='text-primary' style={{ textDecoration: 'underline' }}>Stock Received:</h5>
                                {docsData
                                    .filter((item) => item.ReferenceType === "StockReceived")
                                    .map((item, index) => (
                                    <div className="col-12 col-md-4" key={index}>
                                        <div style={{ position: "relative" }} className="profile-info">
                                            <div
                                                className="profile-pic"
                                                style={{ position: "relative", display: "inline-block" }}
                                            >
                                                <img
                                                    src={getFileTypeImage(item.FilePath)}
                                                    className="rounded img-fluid"
                                                    alt={`File ${index}`}
                                                    style={{ width: "100%", height: "5rem" }}
                                                />
                                                <a
                                                    href={`https://pcuploadfiles.azurewebsites.net/download?path=${item.FilePath}`}
                                                    download={`File-${index}`}
                                                    style={{
                                                        position: "absolute",
                                                        top: "3px",
                                                        right: "3px",
                                                        color: "white",
                                                        fontSize: "15px",
                                                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                                                        padding: "5px",
                                                        borderRadius: "50%",
                                                        cursor: "pointer",
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    <i
                                                        className="fa-solid fa-download"
                                                        title="Download file"
                                                    ></i>
                                                </a>
                                            </div>
                                            <p className="text-start fw-bold text-info">{item.DocType}</p>
                                        </div>
                                    </div>
                                    ))}
                                </>
                            )}

                            {/* Stock Transferred Documents */}
                            {docsData.some((item) => item.ReferenceType === "StockTransfered") && (
                                <>
                                <h5 className='mt-4 text-primary' style={{ textDecoration: 'underline' }}>Stock Transferred:</h5>
                                {docsData
                                    .filter((item) => item.ReferenceType === "StockTransfered")
                                    .map((item, index) => (
                                    <div className="col-12 col-md-4" key={index}>
                                        <div style={{ position: "relative" }} className="profile-info">
                                            <div
                                                className="profile-pic"
                                                style={{ position: "relative", display: "inline-block" }}
                                            >
                                                <img
                                                    src={getFileTypeImage(item.FilePath)}
                                                    className="rounded img-fluid"
                                                    alt={`File ${index}`}
                                                    style={{ width: "100%", height: "5rem" }}
                                                />
                                                <a
                                                    href={`https://pcuploadfiles.azurewebsites.net/download?path=${item.FilePath}`}
                                                    download={`File-${index}`}
                                                    style={{
                                                        position: "absolute",
                                                        top: "3px",
                                                        right: "3px",
                                                        color: "white",
                                                        fontSize: "15px",
                                                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                                                        padding: "5px",
                                                        borderRadius: "50%",
                                                        cursor: "pointer",
                                                        textDecoration: "none",
                                                    }}
                                                    >
                                                    <i
                                                        className="fa-solid fa-download"
                                                        title="Download file"
                                                    ></i>
                                                </a>
                                            </div>
                                            <p className="text-start fw-bold text-info">{item.DocType}</p>
                                        </div>
                                    </div>
                                    ))}
                                </>
                            )}

                            {/* Other Uploaded Documents */}
                            {docsData.some(
                                (item) => item.ReferenceType !== "StockReceived" && item.ReferenceType !== "StockTransfered"
                            ) && (
                                <>
                                <h5 className='text-primary' style={{ textDecoration: 'underline' }}>Uploaded Documents:</h5>
                                {docsData
                                    .filter(
                                    (item) =>
                                        item.ReferenceType !== "StockReceived" &&
                                        item.ReferenceType !== "StockTransfered"
                                    )
                                    .map((item, index) => (
                                    <div className="col-12 col-md-4" key={index}>
                                        <div style={{ position: "relative" }} className="profile-info">
                                            <div
                                                className="profile-pic"
                                                style={{ position: "relative", display: "inline-block" }}
                                            >
                                                <img
                                                    src={getFileTypeImage(item.FilePath)}
                                                    className="rounded img-fluid"
                                                    alt={`File ${index}`}
                                                    style={{ width: "100%", height: "5rem" }}
                                                />
                                                <a
                                                    href={`https://pcuploadfiles.azurewebsites.net/download?path=${item.FilePath}`}
                                                    download={`File-${index}`}
                                                    style={{
                                                        position: "absolute",
                                                        top: "3px",
                                                        right: "3px",
                                                        color: "white",
                                                        fontSize: "15px",
                                                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                                                        padding: "5px",
                                                        borderRadius: "50%",
                                                        cursor: "pointer",
                                                        textDecoration: "none",
                                                    }}
                                                    >
                                                    <i
                                                        className="fa-solid fa-download"
                                                        title="Download file"
                                                    ></i>
                                                </a>
                                            </div>
                                            <p className="text-start fw-bold text-info">{item.DocType}</p>
                                        </div>
                                    </div>
                                    ))}
                                </>
                            )}
                            </>
                        )}
                    </div>

                </div>
            </div>
        </div>
    )
}

UploadFiles.propTypes = {
    number: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
};


export default UploadFiles;
